<template>
    <div v-if="active" class="card">
        <a class="theme-primary help-icon icon text-right" href="login-help.html" target="_blank" alt="Login Help">
            <fa-icon :icon="['fas','question-circle']" /><span class="sr-only">login help</span>
        </a>
        <div class="card-body">
            <PageHeader :title="screenData.text.cardTitle" variant="small" />
            <p>{{screenData.text.currentlyDown}}</p>
            <p>{{screenData.text.inconvenienceSorry}}</p>
        </div>
    </div>
</template>

<script>
    import PageHeader from '../entities/PageHeader.vue';

    export default {
        name: "PardonUs",

        components: {
           PageHeader
        },

        data: function() {
            return {
                active: false
            }
        },

        props: {
            screenData: Object
        },

        methods: {
            show: function() {
                this.active = true;
            },

            hide: function() {
                this.active = false;
            }
        }
    }
</script>